export default "__VITE_ASSET__DtpOM4Z___"